/** ui2026: starter questions offered wherever a user can chat about a flag
 *  (Predict side peek and the flag-launched Copilot chat). */
export const FLAG_CHAT_SUGGESTIONS = [
  "Why was this patient flagged?",
  "Draft an SBAR for the attending",
  "Show vitals for the past week",
  "Has this happened before?",
] as const;
